export default {
  title: 'Kaupan verkkotunnus',
  description:
    'Tarjoa ravintoloidesi verkkokaupat omalla verkkotunnuksellasi jaetun osoitteen sijaan — esimerkiksi pizza-mario.order-yourbrand.com. Lisäät kaksi DNS-tietuetta kerran; jokainen myöhemmin lisättävä ravintola saa osoitteensa automaattisesti.',
  read_only_description:
    'Verkkotunnus, jolla tämän kumppanin ravintoloiden verkkokaupat toimivat. Vain kumppani voi yhdistää tai muuttaa sitä.',
  read_only_empty: 'Tämä kumppani ei ole yhdistänyt kaupan verkkotunnusta.',
  not_connected: {
    label: 'Ravintoloidesi kauppojen verkkotunnus',
    hint: 'Verkkotunnus tai alitunnus, jonka omistat, kuten order-yourbrand.com. Sen täytyy olla eri verkkotunnus kuin se, jolla tiimisi sovellukset toimivat — ei sen alitunnus.',
    placeholder: 'order-yourbrand.com',
    connect: 'Yhdistä',
  },
  status: {
    pending_dns: 'Odottaa DNS:ää',
    active: 'Käytössä',
    failed: 'Toimenpide vaaditaan',
    disabled: 'Ei linkitetty',
  },
  primary_badge: 'Ensisijainen',
  summary: {
    pending: 'Odotamme DNS-tietueitasi. Tämä kestää yleensä muutaman minuutin, mutta voi kestää muutaman tunnin.',
    failed:
      'Emme pystyneet vahvistamaan kaikkia tietueita ajoissa. Korjaa alla merkitty tietue ja paina sitten Tarkista uudelleen — jatkamme tarkistusta siitä.',
    failed_leave: 'Yhdistääksesi toisen verkkotunnuksen, poista tämän linkitys ensin.',
    live: '{{host}} on käytössä.',
    primary: 'Jokainen uusi ravintola saa osoitteensa sen alle automaattisesti.',
    standby:
      'Tee siitä ensisijainen, jotta se annetaan automaattisesti jokaiselle uudelle ravintolalle. Jo toisella verkkotunnuksella olevat ravintolat pysyvät ennallaan.',
    regressed:
      '{{host}} on käytössä, mutta alla oleva tietue ei enää täsmää. Kauppasi ovat edelleen verkossa — korjaa tietue DNS-palveluntarjoajallasi.',
  },
  instructions: {
    title: 'Näin lisäät tietueet',
    step_provider:
      'Kirjaudu sisään palveluun, jossa verkkotunnuksen {{root}} DNS:ää hallitaan — yleensä yritykseen, josta ostit verkkotunnuksen.',
    step_add: 'Lisää jokainen alla oleva tietue täsmälleen näytetyllä tavalla: sen tyyppi, nimi ja arvo.',
    step_check: 'Tallenna ja napsauta sitten ”{{button}}”. Tarkistamme myös itse jatkuvasti.',
    tip_name:
      'Useimmat palveluntarjoajat haluavat nimikenttään vain osan ennen {{root}} — _foodamigos-verify ja *. Koko nimi näkyy alla niille palveluntarjoajille, jotka sitä kysyvät.',
    tip_wildcard:
      '* -tietue ohjaa jokaisen {{root}}:n alla olevan osoitteen kauppoihisi, joten sinun ei tarvitse lisätä tietuetta jokaiselle ravintolalle.',
    tip_existing:
      'Olemassa olevat tietueet verkkotunnukselle {{root}}, kuten verkkosivusi, sähköpostisi tai www, toimivat edelleen: * -tietue vastaa vain nimiin, joilla ei ole omaa tietuetta. Jos {{root}}:lla on jo * -tietue, korvaa se omallamme.',
    tip_cloudflare: 'Cloudflaressa aseta CNAME-tietue tilaan ”Vain DNS” (harmaa pilvi), tai emme näe sitä.',
  },
  records: {
    title: 'Lisää nämä DNS-tietueet verkkotunnukselle {{root}} verkkotunnuspalveluntarjoajallasi',
  },
  example: 'Ravintola löytyy tällöin osoitteesta kuten {{host}}.',
  example_label: 'sinun-ravintolasi',
  buttons: {
    check_again: 'Tarkista uudelleen',
    make_primary: 'Tee ensisijaiseksi',
    unlink: 'Poista linkitys',
    retry: 'Yritä uudelleen',
  },
  primary_unavailable: 'Saatavilla, kun verkkotunnus on käytössä.',
  unlink_blocked_one:
    '{{count}} ravintola on edelleen tällä verkkotunnuksella. Siirrä se toiselle verkkotunnukselle ennen linkityksen poistamista.',
  unlink_blocked_other:
    '{{count}} ravintolaa on edelleen tällä verkkotunnuksella. Siirrä ne toiselle verkkotunnukselle ennen linkityksen poistamista.',
  unlink_confirm: {
    title: 'Poistetaanko verkkotunnuksen {{host}} linkitys?',
    description: 'Voit yhdistää verkkotunnuksen {{host}} uudelleen myöhemmin.',
    description_primary:
      'Uudet ravintolat saavat jälleen osoitteen jaetulla verkkotunnuksella. Voit yhdistää verkkotunnuksen {{host}} uudelleen myöhemmin.',
    ok: 'Poista linkitys',
  },
  toasts: {
    load_error: 'Kaupan verkkotunnusta ei voitu ladata',
    load_error_read_only: 'Tämän kumppanin kaupan verkkotunnusta ei voitu ladata',
    connected: 'Verkkotunnus yhdistetty — lisää nyt alla olevat tietueet',
    connect_failed: 'Verkkotunnusta ei voitu yhdistää',
    check_started: 'Tarkistetaan uudelleen…',
    check_failed: 'Tarkistusta ei voitu käynnistää. Yritä uudelleen minuutin kuluttua.',
    primary_set: 'Uudet ravintolat saavat nyt tämän verkkotunnuksen',
    primary_failed: 'Verkkotunnusta ei voitu asettaa ensisijaiseksi',
    unlinked: 'Verkkotunnuksen linkitys poistettu',
    unlink_failed: 'Verkkotunnuksen linkitystä ei voitu poistaa',
    unlink_has_restaurants_one:
      '{{count}} ravintola on edelleen verkkotunnuksella {{host}}: {{names}}. Siirrä se toiselle verkkotunnukselle ennen linkityksen poistamista.',
    unlink_has_restaurants_other:
      '{{count}} ravintolaa on edelleen verkkotunnuksella {{host}}: {{names}}. Siirrä ne toiselle verkkotunnukselle ennen linkityksen poistamista.',
    gone: '{{host}} ei ole enää yhdistetty — se on saatettu poistaa toisessa välilehdessä.',
  },
};
